import { ThunkType } from "../../../../../core/store/reducers";
import { getTradeByBrokersReport } from "../api/getTradeByBrokersReport";
import fileDownload from "js-file-download";
import { setFetchState } from "../tradeByBrokersDataSlice";

export const downloadTradeByBrokersReport = (): ThunkType => async (
  dispatch,
  getStore
) => {
  const store = getStore();

  if (store.data.auth.current.status !== "successful") {
    return undefined;
  }

  const { filter } = store.ux.reports.exchbusiness.tradeByBrokers;
  const user = store.data.auth.current.user;
  dispatch(setFetchState({ type: "started" }));
  const ordersReport = await dispatch(getTradeByBrokersReport(user, filter));
  if (ordersReport) {
    fileDownload(
      new Blob([ordersReport as any], { type: "application/pdf" }),
      "TradeByBrokers.pdf"
    );
  }
  dispatch(setFetchState({ type: "not-started" }));
};
